<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="download-banner-wrapper">
    <div class="download-button-wrapper">
      <p>고시락 앱을 다운받아 보세요!</p>
      <a href="https://play.google.com/store/apps/details?id=kosirock2.winni.com&hl=ko" target="_blank"><img src="../../assets/images/layer-29.png" alt="고시락 PlayStore 이동 버튼"/></a>
      <a @click="readyToApp" href="javascript:void(0);"><img src="../../assets/images/layer-28.png" alt="고시락 AppStore 이동 버튼"/></a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DownloadBanner',
    methods: {
      readyToApp () {
        alert('IOS 앱은 서비스 준비중입니다.')
      },
      moveToStore () {
      }
    }
  }
</script>

<style scoped lang="less">
  .download-banner-wrapper {
    margin-top: 3rem;
    background: url('../../assets/images/down_banner.jpg') no-repeat no-repeat;
    background-size: cover;
    width: 100%;
    max-height: 20rem;
    height: 20rem;
    text-align: right;

    .download-button-wrapper {
      height:100%;
      display:flex;
      align-items:flex-end;
      flex-direction: column;
      justify-content: center;
      padding: 0 10rem;

      p {
        padding: 1.4rem 0;
        font-weight: bold;
      }

      a {
        padding: 0;
        margin: 0.5rem 0;
        background:transparent;
        display: block;
      }
    }
  }
</style>
